export const AUTH_SLICE_LOCALSTORAGE_NAME = "authInfo"

export const BASE_URL = process.env.REACT_APP_BASE_URL